import Controller from "csi/action/Controller";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";

const MoveDocuments = declare(Controller, {

	/**
	 * @override
	 * Add Parameter ParentURL to operation
	 */
	toWriterRequest() {
		const call: CallMethod = this.inherited<CallMethod>(arguments);
		call.addParameter("ParentURL", xml.ATTR_REF, this.getCache().getNode(this.m_urlParent).__Parent__);
		return call;
	},
});

export = MoveDocuments;
